import { render, staticRenderFns } from "./CartModalNew.vue?vue&type=template&id=f9dffb36&scoped=true&"
import script from "./CartModalNew.vue?vue&type=script&lang=js&"
export * from "./CartModalNew.vue?vue&type=script&lang=js&"
import style0 from "./CartModalNew.vue?vue&type=style&index=0&id=f9dffb36&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dffb36",
  null
  
)

export default component.exports